// hooks/useModal.tsx
import React, { createContext, useCallback, useContext, useState } from 'react';
import Modal from '~/components/modal';

type ModalProps = React.ComponentPropsWithoutRef<typeof Modal>;

interface ModalContextData {
  openModal: (props: Omit<ModalProps, 'isVisible'>) => void;
  closeModal: () => void;
  updateModal: (partial: Partial<Omit<ModalProps, 'isVisible'>>) => void;
}

const ModalContext = createContext<ModalContextData>({} as ModalContextData);

export const ModalProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [visible, setVisible] = useState(false);

  const [modalProps, setModalProps] = useState<Omit<
    ModalProps,
    'isVisible'
  > | null>(null);

  const closeModal = useCallback(() => {
    setVisible(false);
  }, []);
  const updateModal = useCallback(
    (partial: Partial<Omit<ModalProps, 'isVisible'>>) => {
      setModalProps((prev) =>
        prev ? { ...prev, ...partial } : { ...(partial as any) },
      );
    },
    [],
  );
  const openModal = useCallback(
    (props: Omit<ModalProps, 'isVisible'>) => {
      setModalProps({
        positiveLabel: 'Ok',
        widthInPercent: 40,
        ...props,
      });
      setVisible(true);
    },
    [closeModal],
  );
  console.log('IS VISIBLE', visible);
  return (
    <ModalContext.Provider value={{ openModal, closeModal, updateModal }}>
      {children}

      <Modal
        open={visible}
        positiveAction={() => {
          modalProps?.positiveAction?.();
          closeModal();
        }}
        onClose={() => {
          modalProps?.negativeAction?.();
          closeModal();
        }}
        {...(modalProps as any)}
      />
    </ModalContext.Provider>
  );
};

export function useModal() {
  return useContext(ModalContext);
}
